<style>
.v-text-field__details {
    padding-top: 0;
    margin-bottom: -7px !important;
}

</style>
<template>
    <v-form ref="formRef" v-model="formValid">
        <v-row dense style="margin-top:2px">
            <v-col cols="12" md="12">
                <v-text-field v-model="form.tanggal_bayar" type="date" label="Tanggal Bayar" :rules="[rules.required]"
                    outlined dense />
            </v-col>

            <v-col cols="12" md="12">
                <v-file-input v-model="form.bukti_bayar" label="Upload Bukti Bayar" prepend-icon="mdi-camera"
                    show-size accept="image/*,application/pdf" :rules="[rules.required]" outlined dense  class="no-attachment-icon"/>
            </v-col>

            <v-col cols="12" class="text-right">
                <v-btn color="primary" @click="submitForm">Simpan Pembayaran</v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { EventBus } from './../../../event-bus'
export default {
    props: {
        id: {
            type: [String, Number],
            required: true,
        },
    },
    data() {
        return {
            form: {
                tanggal_bayar: '',
                bukti_bayar: null,
            },
            formValid: false,
            rules: {
                required: (v) => !!v || 'Harus diisi',
            },
        };
    },
    methods: {
        async submitForm() {
            const isValid = await this.$refs.formRef.validate();
            if (!isValid) return;

            const formData = new FormData();
            formData.append('tanggal_bayar', this.form.tanggal_bayar);
            formData.append('bukti_bayar', this.form.bukti_bayar);

            try {
                const res = await axios.post(`api/utang/${this.id}/bayar`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });

                Toast.fire({ icon: 'success', title: res.data.message });
                this.$emit('submitted'); // emit event ke parent
                EventBus.$emit('utang:updated');
                EventBus.$emit('modal:close');
            } catch (err) {
                console.error(err);
                alert('Gagal menyimpan pembayaran');
            }
        },
    },
};
</script>
